var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BetListDialog',{attrs:{"dialog":_vm.dialog,"title":"Bet History","max-height":500,"max-width":"950px","show-type":"true"},on:{"closeDialog":_vm.hideDialog}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }